/* eg-oregano-header — the promo strip's countdown (and the sale bar's).

   One hour per session, kept in sessionStorage so it does not restart on every
   page view, and rolled over when it runs out — the same clock the earlier
   eg- landers run. */
(function () {
  'use strict';

  var TOTAL = 60 * 60 * 1000;
  var KEY = 'eghSaleEnd';

  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function init(root) {
    if (!root || root.dataset.eghInit === 'true') return;
    root.dataset.eghInit = 'true';

    var el = root.querySelector('[data-egh-countdown]');
    var hours = root.querySelector('[data-egh-hours]');
    var mins = root.querySelector('[data-egh-mins]');
    var secs = root.querySelector('[data-egh-secs]');
    if (!el && !hours) return;

    var end = parseInt(sessionStorage.getItem(KEY) || '0', 10);
    if (!end || end < Date.now()) end = remember(Date.now() + TOTAL);

    function remember(value) {
      try {
        sessionStorage.setItem(KEY, String(value));
      } catch (e) {
        /* private mode — the in-memory value still counts down */
      }
      return value;
    }

    function tick() {
      var left = Math.max(0, end - Date.now());
      var s = Math.floor(left / 1000);
      var h = pad(Math.floor(s / 3600));
      var m = pad(Math.floor((s % 3600) / 60));
      var sec = pad(s % 60);
      if (el) el.textContent = h + ':' + m + ':' + sec;
      // the sale bar shows each unit in its own cell
      if (hours) hours.textContent = h;
      if (mins) mins.textContent = m;
      if (secs) secs.textContent = sec;
      if (left <= 0) end = remember(Date.now() + TOTAL);
    }

    tick();
    setInterval(tick, 1000);
  }

  function boot() {
    var roots = document.querySelectorAll('[data-egh]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
